import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';

import ExchangeConfirmSelectionWithwarning from './ExchangeConfirmSelectionWithWarning';

export default injectIntl(withRouter(ExchangeConfirmSelectionWithwarning));
